import type { ApiKeyStatus, ApiKeyScope, WebhookEvent } from "@cx/domain";
import type { McpProposalView, WebhookDeliveryStatus } from "@cx/contracts";
import type { Tone } from "@cx/ui";

/** Escopos da chave de API em português (T3.8). */
export const SCOPE_LABEL: Record<ApiKeyScope, string> = {
  "contacts:read": "Contatos · ler",
  "contacts:create": "Contatos · criar",
  "contacts:update": "Contatos · editar",
  "products:read": "Produtos · ler",
  "products:create": "Produtos · criar",
  "products:update": "Produtos · editar",
  "products:read_cost": "Produtos · ver custo",
  "warehouses:read": "Depósitos · ler",
  "stock:read": "Estoque · ler",
  "stock:create": "Estoque · lançar",
  "statuses:read": "Situações · ler",
  "sales_orders:read": "Pedidos de venda · ler",
  "sales_orders:create": "Pedidos de venda · criar",
  "sales_orders:update": "Pedidos de venda · editar",
  "purchase_orders:read": "Pedidos de compra · ler",
  "purchase_orders:create": "Pedidos de compra · criar",
  "purchase_orders:update": "Pedidos de compra · editar",
  "invoices:read": "Notas fiscais · ler",
  "receivables:read": "Contas a receber · ler",
  "receivables:create": "Contas a receber · criar",
  "receivables:update": "Contas a receber · baixar/cancelar",
  "payables:read": "Contas a pagar · ler",
  "payables:create": "Contas a pagar · criar",
  "payables:update": "Contas a pagar · baixar/cancelar",
  "dashboard:read": "Métricas de vendas (MCP)",
  "copilot:read": "MCP server (ferramentas do Copiloto)",
};

export const EVENT_LABEL: Record<WebhookEvent, string> = {
  "contact.created": "Contato criado",
  "contact.updated": "Contato alterado",
  "product.created": "Produto criado",
  "product.updated": "Produto alterado",
  "stock.changed": "Estoque alterado",
  "sales_order.created": "Pedido de venda criado",
  "sales_order.updated": "Pedido de venda alterado",
  "sales_order.status_changed": "Pedido de venda mudou de situação",
  "purchase_order.created": "Pedido de compra criado",
  "purchase_order.updated": "Pedido de compra alterado",
  "purchase_order.status_changed": "Pedido de compra mudou de situação",
  "purchase_order.received": "Pedido de compra recebido",
  "invoice.authorized": "Nota fiscal autorizada",
  "invoice.rejected": "Nota fiscal rejeitada",
  "invoice.canceled": "Nota fiscal cancelada",
  "title.created": "Conta criada",
  "title.updated": "Conta alterada",
  "title.paid": "Conta baixada",
  "title.canceled": "Conta cancelada",
};

export const KEY_STATUS: Record<ApiKeyStatus, [string, Tone]> = {
  active: ["Ativa", "success"],
  expired: ["Expirada", "secondary"],
  revoked: ["Revogada", "danger"],
};

export const DELIVERY_STATUS: Record<WebhookDeliveryStatus, [string, Tone]> = {
  pending: ["Pendente", "warning"],
  delivering: ["Enviando", "info"],
  delivered: ["Entregue", "success"],
  failed: ["Falhou", "danger"],
  skipped: ["Ignorada", "secondary"],
};

export const PROPOSAL_STATUS: Record<McpProposalView["status"], [string, Tone]> = {
  pending: ["Aguardando", "warning"],
  accepted: ["Aprovada", "success"],
  rejected: ["Rejeitada", "secondary"],
  expired: ["Expirada", "secondary"],
};

export const DISABLED_REASON: Record<string, string> = {
  manual: "desativada manualmente",
  failures: "desativada por falhas seguidas",
  gone: "o destino respondeu 410 (não existe mais)",
};

export const EXPIRY_OPTIONS = [
  { days: 30, label: "30 dias" },
  { days: 90, label: "90 dias" },
  { days: 180, label: "180 dias" },
  { days: 365, label: "1 ano" },
  { days: 730, label: "2 anos" },
];
